import React from "react";
import Chart from "react-apexcharts";
import { Card } from "reactstrap";

const RevenueChart = () => {
  // Mock Data: Replace with API response later
  const categories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const revenueData = [12500, 15000, 18000, 14500, 22000, 26000, 24000, 28500, 32000, 29000, 35000, 42000];

  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      fontFamily: 'inherit',
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    xaxis: {
      categories: categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: { colors: '#9ca3af', fontSize: '12px' }
      }
    },
    yaxis: {
      labels: {
        formatter: (value) => `$${(value / 1000).toFixed(1)}k`,
        style: { colors: '#9ca3af', fontSize: '12px' }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [50, 100]
      }
    },
    colors: ["#3b82f6"],
    tooltip: {
      theme: 'dark',
      y: {
        formatter: (val) => `$${val.toLocaleString()}`
      }
    },
    grid: {
      borderColor: '#f3f4f6',
      strokeDashArray: 4,
    }
  };

  const chartSeries = [
    {
      name: "Revenue",
      data: revenueData,
    },
  ];

  return (
    <Card className="chart-card border-0 shadow-sm rounded-4 h-100 p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fs-18 fw-bold text-dark mb-1">Revenue Trends</h3>
          <p className="fs-13 text-muted mb-0">Monthly revenue overview for the current year</p>
        </div>
        <span className="badge bg-primary-soft text-primary px-3 py-2 rounded-pill">Year 2024</span>
      </div>
      
      <div style={{ minHeight: '320px' }}>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height={320}
          width="100%"
        />
      </div>
    </Card>
  );
};

export default RevenueChart;
